import * as types from '../../mutation_types';
import { https } from './http';

export function getForReleasePurchaseReturn(page,currentpage,sortby,sortdir,search,company,supplier,user,material,date_from,date_to){
    return https().get(`getForReleasePurchaseReturn?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}
        &company=${company}&supplier=${supplier}&user=${user}&material=${material}&date_from=${date_from}&date_to=${date_to}
    `);
}

const state = {
    id:'',
    header:{},
    page:1,
    currentpage:5,
    loading:false,
    search:'',
    data:{},
    add_item:false,
    added_items:[],
    update_item:new FormData(),
    update_header:new FormData(),
    return:{},
    show_history:false,
    histories:[],
    // 11/19/2021 start
    print:false, 
    print_data:[]
    // end 
}
const getters = {
    header:state=>state.header,
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    loading:state=>state.loading,
    search:state=>state.search,
    data:state=>state.data,
    add_item:state=>state.add_item,
    added_items:state=>state.added_items,
    update_item:state=>state.update_item,
    update_header:state=>state.update_header,
    return:state=>state.return,
    show_history:state=>state.show_history,
    histories:state=>state.histories,
    // 11/19/2021 start
    print:state=>state.print,
    print_data:state=>state.print_data
    // end
};
const actions = {
    async fetchPrHeader({commit}){
        let uri = `purchase-return-header/${state.id}`;
        await https().get(uri).then(response=>{
            commit(types.PURCHASE_RETURN_DETAILS_HEADER,response.data);
        }).catch(error=>{
            console.log(error);
        })
    },
    async updatePrHeader({commit}){
        let uri = `purchase-return-header/${state.id}`;
        await https().post(uri,state.update_header).then(response=>{
            console.log(response);
        }).catch(error=>{
            console.log(error);
        })
    },
    async approvePurchaseReturn({commit}){
        let uri = `purchase-return-header/${state.id}`;
        await https().post(uri,state.update_header).then(response=>{
            commit(types.PURCHASE_RETURN_DETAILS_RETURN,response.data);
        }).catch(error=>{
            console.log(error);
            let response = {
                icon:'error',
                message:'Internal Server Error.'
            };
            commit(types.PURCHASE_RETURN_DETAILS_RETURN,response);
        })
    },
    async fetchPrDetails({commit}){
        commit(types.PURCHASE_RETURN_DETAILS_LOADING);
        let uri = `purchase-return-detail/${state.id}?page=${state.page}&currentpage=${state.currentpage}&search=${state.search}`;
        await https().get(uri).then(response=>{
            commit(types.PURCHASE_RETURN_DETAILS_ITEMS,response.data);
            commit(types.PURCHASE_RETURN_DETAILS_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.PURCHASE_RETURN_DETAILS_LOADING);
        })
    },
    // 11/19/2021 start
    async fetchPrDetailsForPrint({commit}){
        let uri = `purchase-return-detail/${state.id}/edit`;
        await https().get(uri).then(response=>{
            commit(types.APP_PURCHASE_RETURN_PRINT_DATA,response.data);
        })
    },
    // end
    async updatePrDetails({commit}){
        let uri = `purchase-return-detail/${state.id}`;
        await https().post(uri,state.update_item).then(response=>{
            console.log(response);
        }).catch(error=>{
            console.log(error);
        })
    },
    async storePrDetails({commit,dispatch}){
        let form_data = new FormData();
        form_data.append('control_number',state.header.control_number);
        form_data.append('items',JSON.stringify(state.added_items));
        let uri = `purchase-return-detail`;
        await https().post(uri,form_data).then(response=>{
            console.log(response);
        }).catch(error=>{
            console.log(error);
        })
    },
    async fetchHistories({commit}){
        let uri = `activities/${state.header.id}/edit?subject_type=PurchaseReturnHeader`;
        await https().get(uri).then(response=>{
            commit(types.PURCHASE_RETURN_DETAILS_HISTORY_DATA,response.data);
        }).catch(error=>{
            console.log(error);
        })
    }
};
const mutations = {
    [types.PURCHASE_RETURN_DETAILS_ID](state,data){
        state.id = data;
    },
    [types.PURCHASE_RETURN_DETAILS_HEADER](state,data){
        state.header = data;
    },
    [types.PURCHASE_RETURN_DETAILS_PAGE](state,data){
        state.page = data;
    },
    [types.PURCHASE_RETURN_DETAILS_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.PURCHASE_RETURN_DETAILS_SEARCH](state,data){
        state.search = data;
    },
    [types.PURCHASE_RETURN_DETAILS_LOADING](state){
        state.loading = !state.loading;
    },
    [types.PURCHASE_RETURN_DETAILS_ITEMS](state,data){
        state.data = data;
    },
    [types.PURCHASE_RETURN_DETAILS_ADD_ITEM](state){
        state.add_item = !state.add_item;
    },
    [types.PURCHASE_RETURN_DETAILS_UPDATE_ITEM](state,data){
        state.update_item = data;
    },
    [types.PURCHASE_RETURN_DETAILS_ADDED_ITEMS](state,data){
        state.added_items = data;
    },
    [types.PURCHASE_RETURN_DETAILS_UPDATE_HEADER](state,data){
        state.update_header = data;
    },
    [types.PURCHASE_RETURN_DETAILS_RETURN](state,data){
        state.return = data;
    },
    [types.PURCHASE_RETURN_DETAILS_HISTORY](state){
        state.show_history = !state.show_history;
    },
    [types.PURCHASE_RETURN_DETAILS_HISTORY_DATA](state,data){
        state.histories = data;
    },
    // 11/19/2021 start
    [types.APP_PURCHASE_RETURN_PRINT](state){
        state.print = !state.print
    },
    [types.APP_PURCHASE_RETURN_PRINT_DATA](state,data){
        state.print_data = data;
    }
    // end
};
export {
    state,getters,actions,mutations 
}